import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
// eslint-disable-next-line no-undef
Vue.axios.defaults.baseURL = config ? config.VUE_APP_AI_API_BASE_URL || process.env.VUE_APP_AI_API_BASE_URL : process.env.VUE_APP_AI_API_BASE_URL
